import { Component, ElementRef, ViewChild } from '@angular/core'
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexTitleSubtitle,
  ApexStroke,
  ApexGrid,
  ApexFill,
  ApexMarkers,
  ApexYAxis,
  ApexPlotOptions,
  ApexResponsive,
  ApexAnnotations,
  ApexLegend,
  ApexTooltip,
} from 'ng-apexcharts'
import { CommonApiService } from 'src/app/services/common-api-service'
import { API_Const } from 'src/app/shared/constants/apiRouteConst'
import { PopupService } from 'src/app/services/popup.service';
import { TranslateService } from '@ngx-translate/core';
import { convertNum, convertNumToCurr, convertNumTwoDec } from 'src/app/shared/constants/app-enums';
import { DatePipe } from '@angular/common';
import { EventService } from 'src/app/services/event.service';


export type ChartOptions = {
  series: ApexAxisChartSeries
  chart: ApexChart
  xaxis: ApexXAxis
  dataLabels: ApexDataLabels
  grid: ApexGrid
  fill: ApexFill
  markers: ApexMarkers
  yaxis: ApexYAxis
  stroke: ApexStroke
  title: ApexTitleSubtitle
  plotOptions: ApexPlotOptions,
  responsive: ApexResponsive,
  annotations: ApexAnnotations,
  // legend: ApexLegend,
  tooltip: ApexTooltip
}

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})


export class HomeComponent {


  @ViewChild("chart") chart: any;
  isMobile = (window.matchMedia &&  window.matchMedia("(max-device-width: 1024px)").matches) ||  screen.width <= 1024;
  destinationAddress = "";
  chartOptions: Partial<ChartOptions> | any;
  pageNo:number = 0;
  wsmValues: any;
  revenueData: any;
  revenueData_dummy: any = [
    {
      title: "casino_24h_revenue",
      tooltip: "casino_tooltip",
      percent: 0,
      revenueUsd: 0,
      revenueWsm: 0,
      chartData: [],
    },
    {
      title: "sport_24h_revenue",
      tooltip: "sport_tooltip",
      percent: 0,
      revenueUsd: 0,
      revenueWsm: 0,
      chartData: [],
    },
    {
      title: "combined_24h_revenue",
      tooltip: "cmbined_tooltip",
      percent: 0,
      revenueUsd: 0,
      revenueWsm: 0,
      chartData: [],
    },
  ];
  activeUser: any = 0;
  transaction: any;
  items: any;
  tableData: boolean = false;
  chartData: boolean = false;
  mode = "all"; // "24h";

  date!: Date;
  now!: number;
  targetDate: Date = new Date();
  currentDate!: Date;
  liveCounter: any;

  @ViewChild('days', { static: true }) days!: ElementRef; 
  @ViewChild('hours', { static: true }) hours!: ElementRef;
  @ViewChild('minutes', { static: true }) minutes!: ElementRef;
  @ViewChild('seconds', { static: true }) seconds!: ElementRef;

  constructor(
    private apiService: CommonApiService,
    private popupService: PopupService,
    private translateService: TranslateService,
    private datePipe: DatePipe,
    private eventService: EventService,
  ) {
    
    this.getRevenueChart();
    this.getActiveUser();
    this.getWsmValue();
    // this.getTransactionChart(this.mode);
    this.getWsmBurntChart();
    this.getTransactionDetails();
    
    this.setTargetDate();
    setInterval(() => {
      // Check if current time has passed the target time
      this.currentDate = new Date();
      if (this.currentDate.getTime() > this.targetDate.getTime()) {
        // this.setTargetDate(2);
        this.setTargetDate();
      }
    }, 1000);


    this.eventService.getCounter().subscribe((val) => {
       this.liveCounter = val;
    });

    this.chartOptions = {
      total_wsm_burnt_value: 0,
      total_usd_burnt_value: 0,
      series: [
        {
          name: "WSM",
          data: [],
        },
      ],
      // dataLabels: {
      //   enabled: false
      // },
      // legend: {
      //   show: false
      // },
      tooltip: {
        enabled: false,
      },
      chart: {
        height: 220,
        type: "line",
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      stroke: {
        width: 3,
        curve: "straight",
        lineCap: "butt",
        colors: "#72F238",
        dashArray: 0,
      },

      markers: {
        // size: 4,
        // colors: ['#3BBD00'],
        // strokeColors: '#CEF5BD',
        // strokeWidth: 3,
        // hover: {
        //   size: 5,
        // },
      },
      yaxis: {
        // min: 0,
        max: 120000000,
        // show: true,
        // showAlways: true,
        // showForNullSeries: true,
        // seriesName: undefined,
        // opposite: false,
        // reversed: false,
        // logarithmic: false,
        // logBase: 50,
        // tickAmount: 4,
        // forceNiceScale: false,
        // floating: false,
        // decimalsInFloat: undefined,
        labels: {
          show: true,
          align: "right",
          maxWidth: 50,
          minWidth: 0,
          formatter: function (value: any) {
            return convertNumToCurr(value);
          },
          style: {
            fontSize: "12px",
            fontWeight: 600,
            color: "#6F717E",
          },
        },
      },
      xaxis: {
        type: "datetime",
        tickAmount: 'dataPoints',
        // categories: [],
        labels: {
          format: 'MMM-yyyy',
          showDuplicates: false,
          style: {
            fontSize: "12px",
            fontWeight: 600,
            color: "#6F717E",
          },
        },
        axisTicks:  {
          show: false
        }
      },
      grid: {
        borderColor: "#A0A2AA",
        strokeDashArray: 8,
      },
    };

    setInterval(()=> {
      this. getWsmValue();
      // this.getTransactionChart(this.mode);
      this.getWsmBurntChart();
      this. getTransactionDetails();
    }, 1000 * 60 * 2);

    setInterval(()=> this.getActiveUser(), 1000 * 60 * 25);
  }

  setTargetDate(nextMonthCount: number = 1) {
    this.targetDate.setUTCMonth(this.targetDate.getUTCMonth() + nextMonthCount, 1);
    // this.targetDate.setUTCDate(this.targetDate.getUTCDate() - 1);
    this.targetDate.setUTCHours(18, 0, 1, 0);
    this.eventService.setCounter(this.targetDate.getTime());
  }

  // get revenue chart  data
  getRevenueChart() {
    const url = API_Const.chartDataApi;
    this.apiService.get(url).subscribe((res) => {
      // console.log("==== chartDataApi response ==== \n", res);
      this.revenueData = res.result;
      this.revenueData = this.revenueData_dummy.map((item:any, indx: number) => {
        return {...this.revenueData[indx], tooltip: item.tooltip};
      })
    },
    (err)=>{
      this.revenueData = this.revenueData_dummy;
    });
  }

  // active users
  getActiveUser() {
    const url = API_Const.dashActiveUser;
    this.apiService.get(url).subscribe((res) => {
      // console.log("==== active user ====\n", res);
      this.activeUser = res.result.activeUsers;
    });
  }

  // WSM Values
  getWsmValue() {
    const url = API_Const.wsmValue;
    this.apiService.get(url).subscribe((res: any) => {
      // console.log("=====  wsmValue =====\n", res);
      this.wsmValues = res.result;
    });
  }

  // // WSM Values
  // getTransactionChart(val = "24h") {
  //   this.mode = val;
  //   this.chartData = false;
  //   const url = API_Const.transactionChart + val;
  //   this.apiService.get(url).subscribe((res: any) => {
  //     console.log("=====  transactionChart =====\n", res);
  //     this.chartOptions.total_usd_value = res.result.totalUsdValue.toFixed(0);
  //     this.chartOptions.total_wsm_value = res.result.totalWsmValue.toFixed(0);
  //     this.chartOptions.series[0].data = res.result.chartData.map((indx: any) => [new Date(indx.dateOfTx), (+indx.wsmAmount/1000).toFixed(2)]).reverse();
  //     // console.log(this.chartOptions.series[0].data)
  //     this.chartData = true;
  //   });
  // }

  getWsmBurntChart() {
    this.chartData = false;
    const url = API_Const.wsmBurnt;
    this.apiService.get(url).subscribe((res: any) => {
      this.chartOptions.total_wsm_burnt_value = res.result.totalWsmBurnt.toFixed(0);
      this.chartOptions.total_usd_burnt_value = res.result.totalCurrentUsd.toFixed(0);
      this.chartOptions.series[0].data = 
      [
        {
          wsmBurntForMonth: 0,
          wsmBurntTotal: 0,
          time: "2023-11"
        },
        {
          wsmBurntForMonth: 25000000,
          wsmBurntTotal: 100000000,
          time: "2024-02"
        },
        {
          wsmBurntForMonth: 2490619,
          wsmBurntTotal: 102490619,
          time: "2024-03"
        },
        {
          wsmBurntForMonth: null,
          wsmBurntTotal: null,
          time: "2024-04"
        },
        {
          wsmBurntForMonth: null,
          wsmBurntTotal: null,
          time: "2024-05"
        }
      ].map((indx: any) => [new Date(indx.time), indx.wsmBurntTotal]);
      this.chartData = res.result.chart.length != 0;
    });
  }

  // transaction table
  getTransactionDetails() {
    const limit = this.pageNo > 0 ? ((this.pageNo + 1) * 10) : 10;
    const url = API_Const.transactionDetails + `limit=${limit}&page=${this.pageNo}`;
    this.apiService.get(url).subscribe((res: any) => {
      // console.log("=== table Data ==== \n", res);
      this.transaction = res.result;
      this.tableData = true;
    });
  }

  loadMore() {
    this.pageNo++;
    const limit = 10;
    const url = API_Const.transactionDetails + `limit=${limit}&page=${this.pageNo}`;
    this.apiService.get(url).subscribe((res: any) => {
      // console.log("=== table Data ==== \n", res);
      this.transaction.data.push(...res.result.data);
      this.tableData = true;
    });
  }

  convertNumTwoDec(num: any, dec = 2) {
    return convertNumTwoDec(num, dec);
  }

  convertNumToCurr(num: number) {
    return convertNumToCurr(num);
  }

  convertNum(num: number, dec = 2) {
    return convertNum(num, dec);
  }

  //copy URL
  copy() {
    this.popupService.messsageAlert(
      "success",
      this.translateService.instant("successCopy")
    );
  }
}
